'use es6';

const getEventBus = () => {
  const CEUI = window.hubspot.ContentEditorUI;
  if (CEUI && CEUI.eventBus) {
    return CEUI.eventBus;
  }
  throw new Error("EventBus isn't initialized! Make sure start() has been called before trying to get the EventBus");
};
export default getEventBus;